<template>
<a-col :span="24">
    <a-row >
	      <a-row style="margin-bottom: 24px;">
            <a-col :xs="5" :sm="5" :md="2" :lg="2" :xl="2" :xxl="2" 
                style="text-align: right; vertical-align: middle">
                <span style="color: red;">* <span style="color: black; margin-right: 10px;" required>主题</span></span>
            </a-col>
            <a-col :xs="19" :sm="19" :md="22" :lg="22" :xl="22" :xxl="22">
                <a-input placeholder="主题名称" v-model='taskName'>
                </a-input>
            </a-col>
        </a-row >
        <a-row style="margin-bottom: 12px;">
            <a-col :xs="5" :sm="5" :md="2" :lg="2" :xl="2" :xxl="2" 
                style="text-align: right; vertical-align: middle">
                <span style="color: red;">* <span style="color: black; margin-right: 10px;" required>种子词</span></span>
            </a-col>
            <a-col :xs="19" :sm="19" :md="22" :lg="22" :xl="22" :xxl="22">
                <a-select 
                    mode="tags" 
                    :value="seedWords" 
                    @change="handleTag" 
                    placeholder="请输入种子词" 
                    style="width: 100%;" >
                </a-select>
            </a-col>
        </a-row >
        <a-row >
            <a-col :xs="5" :sm="5" :md="2" :lg="2" :xl="2" :xxl="2" 
                style="text-align: right;">
                <a-button 
                    type="primary"  
                    @click= "addThisItem" 
                    style="margin-right: 10px;"> 
                    {{buttonName}} 
                </a-button>
            </a-col>
        </a-row >
    </a-row>
</a-col>
</template>

<script>

export default 
{
    components:
    {
    },

    props: 
    {
        item: 
        {
          type: Object,
          default: function() 
          {
              return {
                taskName: "",
                seedWords: [],
              }
          }
        }
    },

    data () 
    {
        return {
            taskName: this.item.taskName,
            seedWords: this.item.seedWords,
        }
    },

    methods: 
    {
        addThisItem ()
        {
            let swArray= this.seedWords;
            let swString=swArray.join(" ");
            let content={ 
              taskName: this.taskName,
              seedWords: swString,
            }
            if (this.taskName && this.seedWords != "") 
            {
                this.$emit('additem', content, this.item);
            } 
            else 
            {
                this.$message.info("Please fill out require data");
            }   
        },

        handleTag: function(seedWords) 
        {
            this.seedWords = seedWords
        },
    },

    created() 
    {
        if (this.item.id) 
        {
            this.buttonName = "编辑"
        } 
        else 
        {
            this.buttonName = "增加"
        }
    }
}
</script>

<style>
    .preview-item {
         width: 200px;
         height: 300px;
    }  
</style>
